export default __webpack_public_path__ + "static/media/sassy.fe2e23de.gif";